/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { motion } from "framer-motion";

import { images } from "../../constants";

import { AppWrap, MotionWrap } from "../../wrapper";

import "./Testimonial.scss";

const albertHopName = "Albert Hop";
const albertHopRecommendation =
  '"I had the pleasure of working with Ashley during his stint at Backbase. Ashley can be described as a very solid asset when it comes to preparing customer cases, presentations and answering RFPs. It is due to his effort and geniality that we have been able to achieve and exceed goals that we have set within the team that we worked in. I would endorse Ashley in his future endeavors and I hope I will have the pleasure again to work with him in the future."';
const albertHopJobSpec = "Senior Partner Manager Latin America - Backbase.";

const stevenHasnootName = "Steven Hasnoot";
const stevenHasnootRecommendation =
  "\"You don't see every day such a calm, focused, experienced and well spoken sofware developer as Ashley. His unique personality is a big asset in the super fast world of ever changing software development. Where keeping you wits is key. His experience helped us to lift various approaches of us to the next level and he was keen on sharing that experience to others as well. Up until today i'm still amazed on multitasking various projects while not losing sight of quality, speed, the team and his own unique calmness.\"";
const stevenHasnootJobSpec = "Agile Coach at Shop Apotheke Europe.";

const maxKalisName = "Max Kalis";
const maxKalisRecommendation =
  '"Ashley & I worked on building a digital prototype at Lloyds Banking Group. Even back then he had a natural understanding of the bigger picture, beyond just the technical aspects. He\'s an asset in terms of not just those critical technical skills but in terms of people, process, planning, profit. "';
const maxKalisJobSpec = "Performance Career Coach.";

const matthewKiernanderName = "Matthew Kiernander";
const matthewKiernanderRecommendation =
  "Ashley is your quintessential 'go-to' person. He has a high level of technical skill matched by his ability to clearly communicate to both non technical and technical audiences. Paired with a truely delightful persona made him the first choice for a lot of work going on at Info. The way he approaches problems comes from a much more holistic and big picture mindset which helped us build much more effective solutions. Ashley would be a great asset to any project.";
const matthewKiernanderJobSpec = "Developer Advocate - Stack Overflow.";

const sanneAlbreghsName = "Sanne Albreghs";
const sanneAlbreghsRecommendation =
  '"I was lucky enough to have met Ashley during the mentorship project of my school, Codam Coding College. He has been a big help to me as a student software developer, offering to take me on as a mentee. It helps me a lot knowing I can connect Ashley when I am in need of advise or just some motivation. I hope you keep sharing your knowledge and positive vibes!"';
const sanneAlbreghsJobSpec =
  "Codam Coding College Software Engineering Student.";

const aavgeenSinghName = "Aavgeen Singh";
const aavgeenSinggRecommendation =
  "Ashley is an exceptional full-stack developer who quickly integrated into our full-stack team and demonstrated strong adaptability across a range of topics. His positive attitude and impactful presence have been a valuable addition to the team. I’m confident that any team Ashley joins will benefit greatly from his skills and enthusiasm.";
const aavgeenSinghJobSpec = "Engineering Manager @ Enpal Berlin";

export const albertHop = {
  albertHopName,
  albertHopRecommendation,
  albertHopJobSpec,
};

export const stevenHasnoot = {
  stevenHasnootName,
  stevenHasnootRecommendation,
  stevenHasnootJobSpec,
};

export const maxKalis = {
  maxKalisName,
  maxKalisRecommendation,
  maxKalisJobSpec,
};

export const matthewKiernander = {
  matthewKiernanderName,
  matthewKiernanderRecommendation,
  matthewKiernanderJobSpec,
};

export const sanneAlbreghs = {
  sanneAlbreghsName,
  sanneAlbreghsRecommendation,
  sanneAlbreghsJobSpec,
};

export const aavgeenSingh = {
  aavgeenSinghName,
  aavgeenSinggRecommendation,
  aavgeenSinghJobSpec,
};

const testimonialsData = [
  {
    imageRef: images.albert,
    imageName: albertHop.albertHopName,
    jobSpec: albertHop.albertHopJobSpec,
    recommendationText: albertHop.albertHopRecommendation,
  },
  {
    imageRef: images.steven,
    imageName: stevenHasnoot.stevenHasnootName,
    jobSpec: stevenHasnoot.stevenHasnootJobSpec,
    recommendationText: stevenHasnoot.stevenHasnootRecommendation,
  },
  {
    imageRef: images.sanne,
    imageName: sanneAlbreghs.sanneAlbreghsName,
    jobSpec: sanneAlbreghs.sanneAlbreghsJobSpec,
    recommendationText: sanneAlbreghs.sanneAlbreghsRecommendation,
  },
  {
    imageRef: images.max,
    imageName: maxKalis.maxKalisName,
    jobSpec: maxKalis.maxKalisJobSpec,
    recommendationText: maxKalis.maxKalisRecommendation,
  },
  {
    imageRef: images.matthew,
    imageName: matthewKiernander.matthewKiernanderName,
    jobSpec: matthewKiernander.matthewKiernanderJobSpec,
    recommendationText: matthewKiernander.matthewKiernanderRecommendation,
  },
  {
    imageRef: images.aavgeen,
    imageName: aavgeenSingh.aavgeenSinghName,
    jobSpec: aavgeenSingh.aavgeenSinghJobSpec,
    recommendationText: aavgeenSingh.aavgeenSinggRecommendation,
  },
];

const brandData = [
  {
    _id: 1,
    imgUrl: images.babbel,
    name: "babbel",
  },
  {
    _id: 2,
    imgUrl: images.backbase,
    name: "backbase",
  },
  {
    _id: 3,
    imgUrl: images.bizcuit,
    name: "bizcuit",
  },
  {
    _id: 4,
    imgUrl: images.codam,
    name: "codam",
  },
  {
    _id: 5,
    imgUrl: images.gs4e,
    name: "gs4e",
  },
  {
    _id: 6,
    imgUrl: images.han,
    name: "han",
  },
  {
    _id: 7,
    imgUrl: images.info,
    name: "info",
  },
  {
    _id: 15,
    imgUrl: images.kfc,
    name: "kfc",
  },
  {
    _id: 8,
    imgUrl: images.lloyds,
    name: "lloyds",
  },
  {
    _id: 9,
    imgUrl: images.nn,
    name: "nn",
  },
  {
    _id: 10,
    imgUrl: images.opc,
    name: "opc",
  },
  {
    _id: 11,
    imgUrl: images.rodeo,
    name: "rodeo",
  },
  {
    _id: 12,
    imgUrl: images.sgc,
    name: "sgc",
  },
  {
    _id: 13,
    imgUrl: images.thuisbezorgd,
    name: "thuisbezorgd",
  },
  {
    _id: 14,
    imgUrl: images.yum,
    name: "yum",
  },
  {
    _id: 16,
    imgUrl: images.idealLogoFinal,
    name: "ideal",
  },
];

type TestimonialType = {
  feedback: string;
  name: string;
  company: string;
  imageUrl: string;
};

type BrandType = {
  _id: string;
  imgUrl: string;
  name: string;
};

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClick = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <>
      <h2 className="head-text app__testimonial-title">
        Feedback from <span>Clients</span>
      </h2>
      {testimonialsData.length && (
        <>
          <div className="app__testimonial-item app__flex">
            <img
              src={testimonialsData[currentIndex].imageRef}
              alt={testimonialsData[currentIndex].imageName}
            />
            <div className="app__testimonial-content">
              <p className="p-text">
                {testimonialsData[currentIndex].recommendationText}
              </p>
              <div>
                <h4 className="bold-text">
                  {testimonialsData[currentIndex].imageName}
                </h4>
                <h5 className="p-text">
                  {testimonialsData[currentIndex].jobSpec}
                </h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div
              className="app__flex"
              onClick={() =>
                handleClick(
                  currentIndex === 0
                    ? testimonialsData.length - 1
                    : currentIndex - 1,
                )
              }
            >
              <HiChevronLeft />
            </div>

            <div
              className="app__flex"
              onClick={() =>
                handleClick(
                  currentIndex === testimonialsData.length - 1
                    ? 0
                    : currentIndex + 1,
                )
              }
            >
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className="app__testimonial-brands">
        {brandData.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: "tween" }}
            key={brand._id}
          >
            <img src={brand.imgUrl} alt={brand.name} />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "testimonial",
  "app__primarybg",
);
